var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "anchor-reviews" } }, [
    _c("div", { staticClass: "bg-gray2 mb-2" }, [
      _c("div", { staticClass: "row mx-0 align-items-stretch" }, [
        _vm.reviewsStatsAverage
          ? _c(
              "div",
              {
                staticClass: "col-12 col-md-4 d-md-flex p-1 p-md-2",
                attrs: { id: "stats-average" },
              },
              [
                _c("device-rating-reviews", {
                  attrs: {
                    title: _vm.reviewsMessages.ratingTitle,
                    "link-label": _vm.reviewsMessages.ratingLinkLabel,
                    "link-url": _vm.reviewsMessages.ratingLinkUrl,
                    average: _vm.reviewsStatsAverage,
                    text: _vm.reviewsStatsText,
                    summary: _vm.summary,
                    "rating-results-height": 1.375,
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.summary
          ? _c(
              "div",
              {
                staticClass:
                  "col-12 col-md-8 p-1 p-md-2 border-separator d-flex flex-column justify-content-center",
                attrs: { id: "reviews-summary" },
              },
              [
                _c("p", { staticClass: "lead mb-0" }, [
                  _c("span", {
                    staticClass: "icon icon-ai-generative",
                    attrs: { "aria-hidden": "true" },
                  }),
                  _vm._v(" "),
                  _c("strong", [
                    _vm._v("Résumé des " + _vm._s(_vm.reviewCount) + " avis"),
                  ]),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "mb-0" }, [
                  _c("strong", [_vm._v(_vm._s(_vm.summary))]),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "small mb-0 pb-0 disclaimer" }, [
                  _vm._v(
                    "\n                    Ce résumé a été généré par intelligence artificielle à partir des textes des commentaires clients.\n                "
                  ),
                ]),
              ]
            )
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }